'use client';
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'meli_pricing_settings';
// Clave de ofuscación simple — no es cifrado fuerte, pero evita que la key quede en texto plano visible
const XOR_KEY = 'mpricing_2024_xk';

function xorEncrypt(str) {
  return btoa(
    str.split('').map((c, i) =>
      String.fromCharCode(c.charCodeAt(0) ^ XOR_KEY.charCodeAt(i % XOR_KEY.length))
    ).join('')
  );
}

function xorDecrypt(encoded) {
  try {
    const str = atob(encoded);
    return str.split('').map((c, i) =>
      String.fromCharCode(c.charCodeAt(0) ^ XOR_KEY.charCodeAt(i % XOR_KEY.length))
    ).join('');
  } catch {
    return '';
  }
}

function loadSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return {
      ...parsed,
      geminiApiKey: parsed.geminiApiKey ? xorDecrypt(parsed.geminiApiKey) : '',
    };
  } catch {
    return {};
  }
}

function saveSettings(settings) {
  try {
    const toStore = {
      ...settings,
      geminiApiKey: settings.geminiApiKey ? xorEncrypt(settings.geminiApiKey) : '',
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
  } catch {
    // localStorage no disponible
  }
}

export function useSettings() {
  const [settings, setSettings] = useState({ geminiApiKey: '' });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setSettings(loadSettings());
    setLoaded(true);
  }, []);

  const updateSettings = (newSettings) => {
    const merged = { ...settings, ...newSettings };
    setSettings(merged);
    saveSettings(merged);
    // Notificar a otros componentes
    window.dispatchEvent(new Event('settings-updated'));
  };

  return { settings, updateSettings, loaded };
}